import { render, staticRenderFns } from "./RestedCard.vue?vue&type=template&id=2c956b38&scoped=true&"
import script from "./RestedCard.vue?vue&type=script&lang=js&"
export * from "./RestedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c956b38",
  null
  
)

export default component.exports